export const ArcwareStyles = {
  customStyles: {
    ":root": {
      "--color0": "#18181A !important",
      "--color1": "#000000",
      "--color2": "#FFFFFF",
      "--color3": "#DAF693 !important",
      "--color4": "#35b350",
      "--color5": "#ffab00",
      "--color6": "#858588 !important",
      "--color7": "#B5B5B7 !important",
      "--color8": "#41008c",
      "--color9": "#3e0070",
      "--color10": "#2e0052",
      "--color11": "rgba(65,0,139,1) !important",
      "--color12": "#222224 !important",
      "--color13": "#f0f0f2 !important",
      "--colorBoxShadow": "rgba(0, 0, 0, 0.20) !important",
    },
    "*": {
      fontFamily: "system-ui",
    },
    "#shared-stream-container": {
      boxSizing: "border-box",
    },
    "#shared-stream-container::-webkit-scrollbar": {
      width: "10px",
    },
    "#shared-stream-container::-webkit-scrollbar-track": {
      background: "var(--color13)",
      opacity: "0.5",
      borderRadius: "30px",
      borderTop: "20px solid var(--color0)",
      borderRight: "5px solid var(--color0)",
      borderBottom: "20px solid var(--color0)",
      borderLeft: "5px solid var(--color0)",
    },
    "#shared-stream-container::-webkit-scrollbar-track-piece": {
      background: "transparent",
    },
    "#shared-stream-container::-webkit-scrollbar-thumb": {
      background: "var(--color13)",
      width: "8px",
      borderRight: "2px solid var(--color0)",
      borderLeft: "2px solid var(--color0)",
      transition: "all ease-in-out 0.3s",
      borderRadius: "7px",
    },
    "#shared-stream-container::-webkit-scrollbar-thumb:hover": {
      transition: "all ease-in-out 0.3s",
      background: "var(--color3)",
    },
    "#playerUI, #videoElementParent": {
      position: "absolute",
      width: "100%",
      height: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      margin: "auto",
      boxSizing: "border-box",
      pointerEvents: "all",
    },
    "#streamingVideo": {
      maxWidth: "100%",
      maxHeight: "100%",
      boxSizing: "border-box",
      background: "#18181A",
    },
    "#uiFeatures #controls": {
      top: "auto",
      left: "auto",
      bottom: "10px",
      right: "20px",
      display: "flex",
      flexDirection: "column-reverse",
    },
    "#uiFeatures #connection": {
      bottom: "5px",
      left: "10px",
      width: "2.5rem",
      heihgt: "2.5rem",
    },
    "#uiFeatures button": {
      backgroundColor: "var(--color12)",
      border: "none",
      position: "relative",
      width: "45px",
      height: "45px",
      padding: "0.5rem",
      textAlign: "center",
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0px 0px 24px 0px var(--colorBoxShadow)",
      borderRadius: "3px",
      outline: "none",
    },
    "#uiFeatures button:hover, #uiFeatures button:active": {
      padding: "0 !important",
      border: "none",
    },
    "#uiFeatures button #audioIconMuted, #uiFeatures button #audioIconUnmuted, #uiFeatures button #micIconMuted, #uiFeatures button #micIconUnmuted":
      {
        width: "31px",
        height: "28px",
      },
    "#uiFeatures button #maximizeIcon, #uiFeatures button #minimizeIcon": {
      width: "25px",
      height: "25px",
    },
    "#stopIcon, #playIcon": {
      width: "30px",
      height: "30px",
    },
    "#uiFeatures button .tooltiptext": {
      right: "125%",
      left: "auto",
      boxShadow: "0px 0px 24px 0px var(--colorBoxShadow)",
      borderRadius: "3px",
      backgroundColor: "var(--color12)",
      width: "95px",
      visibility: "hidden!important",
    },
    "@media (hover: hover) and (pointer: fine)": {
      "#uiFeatures button:hover .tooltiptext": {
        visibility: "visible!important",
      },
    },
    "#controls>*": {
      marginBottom: "0.5rem",
      display: "block",
      lineHeight: "1.75rem",
      padding: "0.5rem",
      backgroundColor: "var(--color12)",
    },
    "#uiFeatures #settingsIcon, #uiFeatures #statsIcon": {
      width: "27px",
      height: "27px",
    },
    ".svgIcon": {
      fill: "var(--color13)",
    },
    "#uiFeatures button:hover .svgIcon, #uiFeatures button:active .svgIcon": {
      fill: "var(--color12)",
    },
    ".tgl-switch .tgl-slider, .tgl-flat:checked+.tgl-slider": {
      border: "3px solid transparent",
    },
    ".tgl-switch .tgl-slider": {
      background: "none",
    },
    ".tgl-switch .tgl-slider::before": {
      content: "''",
      display: "block",
      background: "var(--color6)",
      position: "absolute",
      height: "50%",
      width: "90%",
      borderRadius: "5px",
      margin: "auto",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
    },
    ".tgl-switch .tgl-slider::after": {
      height: "13px",
      width: "13px",
      borderRadius: "50%",
      top: "-2px",
      left: "-1%",
    },
    ".tgl-flat:checked+.tgl-slider:after": {
      left: "62%",
      background: "var(--color3)",
    },
    ".form-control": {
      backgroundColor: "transparent",
      border: "1px solid var(--color13)",
      borderRadius: "2px",
      color: "var(--color13)",
      textAlign: "left",
      fontFamily: "inherit",
      padding: "5px 15px ",
    },
    ".btn-flat": {
      background: "var(--color3)",
      color: "var(--color12)",
      border: "none",
      padding: "7px 50px",
      cursor: "pointer",
      borderRadius: "4px",
      textTransform: "uppercase",
      minWidth: "175px",
    },
    ".btn-flat:disabled": {
      background: "var(--color7)",
      borderColor: "var(--color3)",
      color: "var(--color3)",
      cursor: "default",
    },
    ".btn-flat:focus": {
      outline: "none",
    },
    ".arcware-logo-loader": {
      position: "relative",
      display: "block",
      width: "12.5%",
      height: "12.5%",
    },
    "#playOverlay img#playButton": {
      width: "5%",
    },
    "#disconnectOverlay, #errorOverlay": {
      textTransform: "initial",
      textAlign: "center",
      fontSize: "20px",
      lineHeight: 2.5,
    },
    "#disconnectOverlay .clickableState": {
      textTransform: "initial",
      textAlign: "center",
      color: "#DAF693",
      padding: "5px",
      fontSize: "18px",
      border: "1px solid #DAF693",
      margin: "25px auto 0",
      width: "180px",
    },
    "#afkOverlay": {
      background: "none",
      transition: "all ease-in-out 0.5s",
      opacity: 1,
      pointerEvents: "initial",
    },
    "#afkOverlayInner": {
      textTransform: "initial",
      background: "#18181A",
      padding: "20px 10px 30px",
      fontSize: "18px",
      width: "360px",
      textAlign: "center",
      lineHeight: 2.5,
    },
    "#afkOverlayInner center::first-line": {
      textTransform: "uppercase",
      color: "#FF8461",
      fontWeight: "bold",
      fontSize: "24px",
    },
    "#afkOverlayInner #afkCountDownNumber": {
      color: "#DAF693",
      fontSize: "26px",
      lineHeight: "22px",
    },
    "#afkOverlayInner center .retry-button": {
      textTransform: "initial",
      textAlign: "center",
      color: "#DAF693",
      padding: "5px",
      fontSize: "18px",
      border: "1px solid #DAF693",
      margin: "25px auto 0",
      width: "180px",
    },
    "#connectOverlay #connectButton": {
      textTransform: "initial",
      textAlign: "center",
      color: "#DAF693",
      padding: "5px 5px 8px",
      fontSize: "18px",
      border: "1px solid #DAF693",
      margin: "25px auto 0",
      width: "180px",
    },

    "#connectOverlay .connection-text": {
      textTransform: "initial",
      textAlign: "center",
      margin: "25px auto 0",
    },
    "#connectOverlay .connection-text .title": {
      color: "#ffffff",
      fontSize: "18px",
      margin: "5px 0",
    },
    "#connectOverlay .connection-text .subtitle": {
      color: "#ffffff",
      opacity: 0.5,
      fontSize: "12px",
      margin: "10px 0",
    },
    "#infoOverlay.hiddenState": {
      display: "none",
    },
    "#disconnectOverlay, #playOverlay, #errorOverlay, #microphoneOverlay, #connectOverlay": {
      background: "#18181A",
      display: "flex",
      transition: "all ease-in-out 0.5s",
      opacity: 1,
      pointerEvents: "initial",
    },
    "#microphoneOverlay": {
      textTransform: "initial",
      padding: "20px 30px",
      fontSize: "14px",
      height: "230px",
      width: "360px",
      textAlign: "center",
      lineHeight: 1.25,
      position: "absolute",
      margin: "auto",
      top: "0",
      bottom: "0",
      left: "0",
      right: "0",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      zIndex: 99999,
    },
    "#microphoneOverlay .title": {
      fontSize: "24px",
      position: "relative",
      marginBottom: "20px",
      color: "#F0F0F2",
    },
    "#microphoneOverlay .title:after": {
      content: "''",
      display: "inline-block",
      animation: "dotty steps(1,end) 1s infinite",
      position: "absolute",
    },
    "#microphoneOverlay p": {
      margin: 0,
      color: "#858588",
    },
    "#microphoneOverlay svg": {
      height: "65px",
      marginBottom: "15px",
      marginTop: "-5px",
    },
    "#microphoneOverlay .svgIcon": {
      fill: "#DAF693",
    },
    "#disconnectOverlay.hiddenState, #playOverlay.hiddenState, #errorOverlay.hiddenState, #afkOverlay.hiddenState, #microphoneOverlay.hiddenState":
      {
        opacity: 0,
        pointerEvents: "none",
      },
    "#disconnectOverlay.mic-overlay-is-visible, #errorOverlay.mic-overlay-is-visible, #infoOverlay.mic-overlay-is-visible":
      {
        opacity: 0,
        pointerEvents: "none",
      },
    "#infoOverlay.hiddenState, #connectOverlay.hiddenState": {
      display: "none",
    },
    "#connectOverlay": {
      display: "flex",
      flexDirection: "column-reverse",
      alignItems: "center",
      justifyContent: "center",
    },
    "#infoOverlay": {
      display: "none",
    },
    ".love-letters-box-root": {
      display: "flex",
      position: "absolute",
      width: "100%",
      height: "100%",
      color: "#ffffff",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      background: "#18181A",
      zIndex: 1,
    },
    ".love-letters-box-root.fade-out": {
      opacity: 0,
      transition: "opacity 0.5s",
    },
    "#letters-block": {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: "auto",
      color: "#ffffff",
      zIndex: 4,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "16px",
      textTransform: "initial",
      textAlign: "center",
    },
    "#letters-wrapper": {
      height: "77px",
      overflow: "hidden",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-end",
      marginTop: "10px",
      paddingBottom: "2px",
    },
    "#letters-wrapper p": {
      textAlign: "center",
      lineHeight: 1.25,
      fontSize: "16px",
    },
    ".letter-animation:nth-last-of-type(1)::after": {
      display: "inline-block",
      animation: "dotty steps(1,end) 1s infinite",
      content: "''",
      position: "absolute",
    },
    ".letter-animation": {
      transition: "all 0.5s ease-in-out",
      transformOrigin: "bottom",
      margin: "0 auto",
    },

    ".letter-animation-enter": {
      animation: "fadeInUp 0.75s ease-out",
    },
    ".letter-animation-exit": {
      opacity: 0,
      scale: 0.9,
      transition: "all ease-in-out 1s",
      margin: 0,
    },
    "@keyframes dotty": {
      "0%": { content: "''" },
      "25%": { content: "'.'" },
      "50%": { content: "'..'" },
      "75%": { content: "'...'" },
      "100%": { content: "''" },
    },
    "@keyframes fadeInUp": {
      from: {
        opacity: 0,
        transform: " translateY(5px)",
        scale: 0.9,
      },
      to: {
        opacity: 1,
        transform: "translateY(0)",
        scale: 1,
      },
    },
    ".hidden": {
      display: "none",
      opacity: 0,
    },
    ".visible": {
      display: "block",
      opacity: 1,
      transition: "opacity 1s ease-out",
    },
  },
};
